// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"5aad70b8","457":"5aad70b8","534":"5aad70b8","571":"5aad70b8","581":"5aad70b8"}[chunkId] + ".chunk.css";
};